// Global site entry point for bundled JavaScript.
// Add shared behaviors here as pages evolve.
document.addEventListener('DOMContentLoaded', () => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) {
    return;
  }

  const popInEls = document.querySelectorAll('.thank-you-pop-in');
  const fadeInEls = document.querySelectorAll('.thank-you-fade-in-up');
  const pulseEls = document.querySelectorAll('.thank-you-success-icon');

  if (!popInEls.length && !fadeInEls.length && !pulseEls.length) {
    return;
  }

  // Force animation replay for page transitions/cached navigations.
  const restartCssAnimation = (el) => {
    el.style.animation = 'none';
    void el.offsetWidth;
    el.style.animation = '';
  };

  popInEls.forEach((el) => {
    restartCssAnimation(el);

    if (getComputedStyle(el).animationName === 'none') {
      el.animate(
        [
          { opacity: 0, transform: 'scale(0.8)' },
          { opacity: 1, transform: 'scale(1)' },
        ],
        {
          duration: 500,
          easing: 'cubic-bezier(0.175, 0.885, 0.32, 1.275)',
          fill: 'forwards',
        }
      );
    }
  });

  fadeInEls.forEach((el) => {
    restartCssAnimation(el);

    if (getComputedStyle(el).animationName === 'none') {
      el.animate(
        [
          { opacity: 0, transform: 'translateY(20px)' },
          { opacity: 1, transform: 'translateY(0)' },
        ],
        {
          duration: 600,
          easing: 'ease-out',
          fill: 'forwards',
          delay: Number.parseFloat(el.style.animationDelay || '0') * 1000,
        }
      );
    }
  });

  pulseEls.forEach((el) => {
    restartCssAnimation(el);

    if (getComputedStyle(el).animationName === 'none') {
      el.animate(
        [
          { transform: 'scale(1)' },
          { transform: 'scale(1.08)' },
          { transform: 'scale(1)' },
        ],
        {
          duration: 2200,
          easing: 'ease-in-out',
          iterations: Number.POSITIVE_INFINITY,
          delay: 800,
        }
      );
    }
  });
});
